import { render } from "./POSAccessDenied.vue?vue&type=template&id=6a75b8cb&scoped=true"
import script from "./POSAccessDenied.vue?vue&type=script&lang=js"
export * from "./POSAccessDenied.vue?vue&type=script&lang=js"

import "./POSAccessDenied.vue?vue&type=style&index=0&id=6a75b8cb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a75b8cb"]])

export default __exports__